import {Component} from '@angular/core';
import {PromotionMessageTypeService} from '../../../services/promotion/promotion-message-type.service';
import {PromotionMessageTypeModel} from '../../../models/promotion-message-type.model';

@Component({
  selector: 'kv-promo-message-type',
  template: `
    <app-kontable
      *ngIf="!show"
      title="{{ 'promotion.messageTypeTitle' | translate }}"
      [columns]="['id', 'code', 'description']"
      [titles]="['#', 'promotion.code', 'promotion.description']"
      [source]="messageType"
      [showInfoButton]="true"
      [showRecoverButton]="false"
      [showDetailsButton]="false"
      [showAddButton]="true"
      [showGlobalFilter]="false"
      (onAdd)="addMessageType()"
      (onEdit)="editMessageType($event)"
      (onRemove)="deleteMessageType($event)">
    </app-kontable>
    <kv-promo-message-type-detail
      *ngIf="show"
      [messageType]="addEditMessageType"
      [titlePage]="titlePage"
      (hide)="toggleShow()"
      (saveMessageType)="save($event)">
    </kv-promo-message-type-detail>
  `
})
export class MessageTypeComponent {

  messageType: PromotionMessageTypeModel[];
  addEditMessageType: PromotionMessageTypeModel;
  show = false;
  titlePage = '';

  constructor(
    private svcMessageType: PromotionMessageTypeService) {
    this.svcMessageType.list().subscribe( (res) => {
      this.messageType = res.data
    });
  }

  reloadList() {
    this.messageType = [];
    this.svcMessageType.list(0, 999999).subscribe( res => {
      this.messageType = res.data;
    });
  }

  addMessageType() {
    this.titlePage = 'promotion.addMessageType';
    this.addEditMessageType = {
      code: '',
      description: ''
    };
    this.toggleShow()
  }

  editMessageType(item) {
    this.titlePage = 'promotion.editMessageType';
    this.addEditMessageType = item;
    this.toggleShow()
  }

  deleteMessageType(item) {
    this.svcMessageType.delete(item.id).subscribe((res) => {
      this.reloadList();
    })
  }

  toggleShow() {
    this.show = !this.show
  }

  save(item) {
    if (!item.id) {
      /*Creazione nuovo touch point*/
      this.svcMessageType.create({
        code: item.code,
        description: item.description
      }).subscribe(() => {
        this.titlePage = '';
        this.addEditMessageType = null;
        this.toggleShow();
        this.reloadList();
      });
    }else {
      /*Modifica touch point esistente CON id e SENZA privacyList*/
      this.svcMessageType.update({
        id: item.id,
        code: item.code,
        description: item.description
      }).subscribe(() => {
        this.titlePage = '';
        this.addEditMessageType = null;
        this.toggleShow();
        this.reloadList();
      });
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/views/promotion/message-type/message-type.component.ts